import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CenterCollege} from '../modules/user/components/dictionary/university/center-college';

@Injectable()
export class CenterCollegeService {

  constructor(private _http: HttpClient) {
  }

  getDictionaryById(id: number) {
    return this._http.get<any>('api/dic/college/get/' + id);
  }

  save(college: CenterCollege) {
    return this._http.post<any>('api/dic/college/save', college);
  }

  getCollegeList(params: any, lang: number) {
    return this._http.post<any>('api/dic/college/getList/' + lang, params);
  }

  getPlatonusCollegeInfoList(params: any) {
    return this._http.post<any>('api/dic/college/platonus/info/list', params);
  }

  getPlatonusCollegeInfo(collegeId) {
    return this._http.get<any>('api/dic/college/platonus/info/' + collegeId);
  }

  getCollegeListByCato(cato) {
    return this._http.get<any>(`api/dic/college/getList/${cato}`);
  }

  getCombined(idCollege: number) {
    return this._http.get<any>('api/dic/college/getCombined/' + idCollege);
  }

  getSeparated(idCollege: number) {
    return this._http.get<any>('api/dic/college/getSeparated/' + idCollege);
  }

  getAllSeparated() {
    return this._http.get<any>('api/dic/college/getAllSeparated');
  }

  getTypes() {
    return this._http.get<any>('api/dic/college/getTypeList');
  }

  getForms() {
    return this._http.get<any>('api/dic/college/getFormList');
  }

  getStates() {
    return this._http.get<any>('api/dic/college/getStateList');
  }

  getCloseReasons() {
    return this._http.get<any>('api/dic/college/getCloseReasonList');
  }

  getCreationTypes() {
    return this._http.get<any>('api/dic/college/getCreationTypeList');
  }

  getListByUserModule(module, elseAll) {
    elseAll = elseAll || false;
    return this._http.get<CenterCollege[]>(`api/dic/college/list/by/user/module/${module}/${elseAll}`);
  }

  getAll() {
    return this._http.get<any>('api/dic/college/all');
  }

  getOpenedUniversities(idCollege: number) {
    return this._http.get<any>('api/dic/college/getOpened/' + idCollege);
  }

  getAllOpenList() {
    return this._http.get<any[]>('api/dic/college/list/opened');
  }

  findOpenListByTypesOrForms(filter: any) {
    return this._http.post<any>('api/dic/college/list/opened/filter', filter);
  }

  getByIds(ids: number[]) {
    return this._http.post<any>('api/dic/college/getByIds', ids);
  }

  getNotCivilUniversityList() {
    return this._http.get<any[]>('api/dic/college/non/civil/list');
  }

  getCollegeSetting(collegeId, code) {
    return this._http.get<any[]>(`api/dic/college/get/setting/${collegeId}/${code}`);
  }

  getCollegeSettingMarkSystem(collegeId) {
    return this._http.get<any>(`api/dic/college/get/setting/${collegeId}/system_of_marks_in_journal`);
  }

  getSportSectionsAndCircles() {
    return this._http.get<any[]>('api/dic/college/sportSectionsAndCircles');
  }
}





// WEBPACK FOOTER //
// ./src/app/common_services/center-college.service.ts